import React, {useEffect} from "react";
import $ from 'jquery';
import {Link, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";
import {confirmAlert} from "../../Components/Alerts/BasicAlert";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#deliveryPrices').DataTable({
      "ajax": {
        url: `${baseUrl}delivery-prices`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        {data: 'delivery_provider', name: 'delivery_provider'},
        {data: 'price_from', name: 'price_from'},
        {data: 'price_to', name: 'price_to'},
        {data: 'cost', name: 'cost'},
        {
          data: 'edit',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button 
                class="btn btn-primary me-2 mb-2 bg-black-transperent edit"
                row-id="${row.id}">
                  Edit
                </button>`;
          },
        },
        {
          data: 'delete',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button 
                class="btn btn-danger me-2 mb-2 bg-black-transperent delete"
                row-id="${row.id}">
                  Delete
                </button>`;
          },
        }
      ],
      columnDefs: [
        {
          targets: [0],
          orderData: [0, 1],
        },
      ],
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/delivery-prices/${id}/edit`);
    });

    table.on('click', 'button.delete', function () {
      const id = $(this).attr("row-id");
      confirmAlert('Do you want to delete?', () => {
        axios.delete(`/delivery-prices/${id}`).then(res => {
          table.draw(false);
        });
      });
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  return (
    <div>
      <div className="d-flex flex-stack mb-5">
        <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
          <Link to='/delivery-prices/create'
                className="btn btn-primary"
          >
            Add delivery price
          </Link>
        </div>
      </div>

      <table id="deliveryPrices" className="table align-middle table-row-dashed fs-6 gy-5">
        <thead>
        <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
          <th>Delivery provider</th>
          <th>Price from</th>
          <th>Price to</th>
          <th>Cost</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
        </thead>
        <tbody className="text-gray-600 fw-bold">
        </tbody>
      </table>
    </div>
  );
}